//==========================================
//⚠️ Keep index files under 100 lines!
//Split logic into submodules as needed.
//==========================================
export const types = {
  UPDATE_CCD_STATUS: "UPDATE_CCD_STATUS",
  ADD_AVAILABLE_INCIDENTS: "ADD_AVAILABLE_INCIDENTS",
  ADD_SELECTED_AVAILABLE_INCIDENT: "ADD_SELECTED_AVAILABLE_INCIDENT",
  ADD_BULK_SELECTED_AVAILABLE_INCIDENTS: "ADD_BULK_SELECTED_AVAILABLE_INCIDENTS",
  REMOVE_SELECTED_AVAILABLE_INCIDENT: "REMOVE_SELECTED_AVAILABLE_INCIDENT",
  REMOVE_BULK_SELECTED_AVAILABLE_INCIDENTS: "REMOVE_BULK_SELECTED_AVAILABLE_INCIDENTS",
  ADD_LAST_UPDATED_TIME: "ADD_LAST_UPDATED_TIME",
  USER_ROLE: "USER_ROLE",
  ROLE_LIST: "ROLE_LIST",
  USER_ROLE_LIST: "USER_ROLE_LIST",
  DEVICES_SELECTED_DATA: "DEVICES_SELECTED_DATA",
  SITES_MODIFIED: "SITES_MODIFIED",
  EVENT_SETTINGS: "EVENT_SETTINGS",
  EVENT_PAGENUMBER: "EVENT_PAGENUMBER",
  UPDATE_BASELINE_INFO: "UPDATE_BASELINE_INFO",
  ACTIVATE_SENSOR: "ACTIVATE_SENSOR",
  ACTIVATE_SENSOR_SUCCESS: "ACTIVATE_SENSOR_SUCCESS",
  SET_SHOW_SENSOR_ACTIVATE_MODAL: "SET_SHOW_SENSOR_ACTIVATE_MODAL",
  FETCHED_CAMERA_DEVICES: "FETCHED_CAMERA_DEVICES",
  FETCH_ALL_DEVICES: "FETCH_ALL_DEVICES",
  UPDATE_ALL_DEVICES: "UPDATE_ALL_DEVICES",
  REMOVE_CAMERA_FROM_LIST: "REMOVE_CAMERA_FROM_LIST",
  FETCHED_UN_PAIRED_CAMERA_DEVICES: "FETCHED_UN_PAIRED_CAMERA_DEVICES",
  FETCH_CAMERA_NAME: "FETCH_CAMERA_NAME",
  FETCH_TAGS: "FETCH_TAGS",
  FETCHED_TAGS: "FETCHED_TAGS",
  FETCH_ALL_TAGS: "FETCH_ALL_TAGS",
  FETCHED_ALL_TAGS: "FETCHED_ALL_TAGS",
  FETCH_ALL_SITES: "FETCH_ALL_SITES",
  FETCHED_ALL_SITES: "FETCHED_ALL_SITES",
  START_POLLING_FOR_REPORTS: "START_POLLING_FOR_REPORTS",
  START_POLLING_FOR_EVENTS: "START_POLLING_FOR_EVENTS",
  STOP_POLLING_FOR_REPORTS: "STOP_POLLING_FOR_REPORTS",
  STOP_POLLING_FOR_EVENTS: "STOP_POLLING_FOR_EVENTS",
  FETCHED_REPORTS: "FETCHED_REPORTS",
  FETCHED_EVENTS: "FETCHED_EVENTS",
  FETCH_GRAPH_DATA: "FETCH_GRAPH_DATA",
  FETCH_COUNTER_COUNT: "FETCH_COUNTER_COUNT",
  FETCHED_COUNTER_COUNT: "FETCHED_COUNTER_COUNT",
  FETCH_EXIT_GRAPH_DATA: "FETCH_EXIT_GRAPH_DATA",
  FETCHED_GRAPH_DATA: "FETCHED_GRAPH_DATA",
  FETCHED_CAM_GRAPH_DATA: "FETCHED_CAM_GRAPH_DATA",
  FETCHED_EXIT_GRAPH_DATA: "FETCHED_EXIT_GRAPH_DATA",
  FETCH_REPORT_DETAILS: "FETCH_REPORT_DETAILS",
  FETCHED_REPORT_DETAILS: "FETCHED_REPORT_DETAILS",
  FETCH_CAMERA_GRAPH_DATA: "FETCH_CAMERA_GRAPH_DATA",
  API_ERROR: "API_ERROR",
  DEFAULT_API_ERROR: "DEFAULT_API_ERROR",
  SET_USER_ROLE: "SET_USER_ROLE",
  ASSIGN_USER_ROLE: "ASSIGN_USER_ROLE",
  NET_TRAFFIC_FLOW_INTERVAL: "NET_TRAFFIC_FLOW_INTERVAL",
  UPDATE_REPORT_POLLING: "UPDATE_REPORT_POLLING",
  UPDATE_AREA_TAGS: "UPDATE_AREA_TAGS",
  UPDATE_RESET_TIME: "UPDATE_RESET_TIME",
  SET_DROPDOWN_VALUE: "SET_DROPDOWN_VALUE",
  SET_ROLE_ERROR: "SET_ROLE_ERROR",
  SET_FIRST_NAME: "SET_FIRST_NAME",
  SET_LAST_NAME: "SET_LAST_NAME",
  SET_PHONE_NUMBER: "SET_PHONE_NUMBER",
  SET_EMAIL: "SET_EMAIL",
  UPDATE_CHECKED_SITES: "UPDATE_CHECKED_SITES",
  UPDATE_SELECTED_GROUPS: "UPDATE_SELECTED_GROUPS",
  UPDATE_INVITE_USER_DATA: "UPDATE_INVITE_USER_DATA",
  COMPANION_SELECTED: "COMPANION_SELECTED",
  FLOOR_SELECTED: "FLOOR_SELECTED",
  AREA_SELECTED: "AREA_SELECTED",
  SUBAREA_SELECTED: "SUBAREA_SELECTED",
  CAMERA_UPDATED: "CAMERA_UPDATED",
  SITE_SELECTED: "SITE_SELECTED",
  FLOOR_AREAS: "FLOOR_AREAS",
  GET_FOVNAMES: "GET_FOVNAMES",
  SET_GROUP_NAME: "SET_GROUP_NAME",
  SET_CHECKED_SITES: "SET_CHECKED_SITES",
  SET_SELECTED_MEMBERS: "SET_SELECTED_MEMBERS",
  SET_ACTIVE_SESSION: "SET_ACTIVE_SESSION",
  UPDATE_ACTIVE_SESSION_DELTA: "UPDATE_ACTIVE_SESSION_DELTA",
  FETCH_COUNTRY_IDS_REQUEST: "FETCH_COUNTRY_IDS_REQUEST",
  FETCH_COUNTRY_IDS_SUCCESS: "FETCH_COUNTRY_IDS_SUCCESS",
  FETCH_COUNTRY_IDS_FAILURE: "FETCH_COUNTRY_IDS_FAILURE",
  FETCH_SITES_REQUEST: "FETCH_SITES_REQUEST",
  PUT_FETCH_COUNTRY_REQUEST: "PUT_FETCH_COUNTRY_REQUEST",
  FETCH_SITES_SUCCESS: "FETCH_SITES_SUCCESS",
  FETCH_SITES_FAILURE: "FETCH_SITES_FAILURE",
  DELETE_SITE_REQUEST: "DELETE_SITE_REQUEST",
  DELETE_SITE_SUCCESS: "DELETE_SITE_SUCCESS",
  DELETE_SITE_FAILURE: "DELETE_SITE_FAILURE",
  SET_COMBINED_COUNTRY_TAGDATA: "SET_COMBINED_COUNTRY_TAGDATA",
  SET_COMBINED_SITES_TAGDATA: "SET_COMBINED_SITES_TAGDATA",
  SET_LOADING: "SET_LOADING",
  UPDATED_SITE_TAG_LIST: "UPDATED_SITE_TAG_LIST",
  ADD_NEW_AREA: "ADD_NEW_AREA",
  ADD_NEW_SUBAREA: "ADD_NEW_SUBAREA",
  PROCESS_NESTED_SITE_TAG_LIST: "PROCESS_NESTED_SITE_TAG_LIST",
  SET_ROI_POLYGON: "SET_ROI_POLYGON",
  SETALLTAGLIST: "SETALLTAGLIST",
  SET_ALL_BASELINEDATA: "SET_ALL_BASELINEDATA",
  SET_ROI_LIST_WITH_CVAPPS: "SET_ROI_LIST_WITH_CVAPPS",
  CREATE_ROI_REQUEST: "CREATE_ROI_REQUEST",
  EDIT_ROI_REQUEST: "EDIT_ROI_REQUEST",
  DELETE_ROI_REQUEST: "DELETE_ROI_REQUEST",
  DELETE_BULK_UNSUBSCRIBE_ROI_REQUEST: "DELETE_BULK_UNSUBSCRIBE_ROI_REQUEST",
  UNSUBSCRIBE_ROI_OF_OBJECTBLURRING: "UNSUBSCRIBE_ROI_OF_OBJECTBLURRING",
  ROI_SUCCESS_RESPONSE: "ROI_SUCCESS_RESPONSE",
  ROI_UPDATE_SUCCESS_RESPONSE: "ROI_UPDATE_SUCCESS_RESPONSE",
  ROI_DELETE_SUCCESS_RESPONSE: "ROI_DELETE_SUCCESS_RESPONSE",
  RESET_ROI: "RESET_ROI",
  FETCH_CV_APP: "FETCH_CV_APP",
  FETCHED_CV_APP: "FETCHED_CV_APP",
  GET_EVENTS: "GET_EVENTS",
  GET_ALL_ROILIST_WITH_CVAPPS: "GET_ALL_ROILIST_WITH_CVAPPS",
  SET_SOURCE_ID: "SET_SOURCE_ID",
  SET_STATISTICS: "SET_STATISTICS",
  ADD_STATISTICS: "ADD_STATISTICS",
  RESET_ONBOARD_CAMERA: "RESET_ONBOARD_CAMERA",
  CAM_BLUR_VALUE: "CAM_BLUR_VALUE",
  SET_CAM_DETAILS: "SET_CAM_DETAILS",
  SET_CAM_QR: "SET_CAM_QR",
  SET_GROUP_DETAILS: "SET_GROUP_DETAILS",
  FETCHED_COMPANION_DEVICES: "FETCHED_COMPANION_DEVICES",
  FETCH_ALL_COMPANION_DEVICES: "FETCH_ALL_COMPANION_DEVICES",
  UPDATE_COMPANION_DEVICE_SITE: "UPDATE_COMPANION_DEVICE_SITE",
  FETCH_ALL_CAMERA_AND_FOVS_DEVICES: "FETCH_ALL_CAMERA_AND_FOVS_DEVICES",
  GET_CAMERA_CREDS_REQUEST: "GET_CAMERA_CREDS_REQUEST",
  GET_CAMERA_CREDS_SUCCESS: "GET_CAMERA_CREDS_SUCCESS",
  GET_CAMERA_CREDS_FAILURE: "GET_CAMERA_CREDS_FAILURE",
  RESET_CAMERA_CREDS: "RESET_CAMERA_CREDS",
  SET_UNPAIRED_CAM_DETAILS: "SET_UNPAIRED_CAM_DETAILS",
  SET_CAM_POSITION: "SET_CAM_POSITION",
  EVENT_ERROR: "EVENT_ERROR",
  UPDATE_SELECTED_LEFT_NAV: "UPDATE_SELECTED_LEFT_NAV",
  UPDATE_RULE_VALUES: "UPDATE_RULE_VALUES",
  LOADING_EVENTS: "LOADING_EVENTS",
  FETCH_RULES_BY_DEVICE_ID_REQUEST: "FETCH_RULES_BY_DEVICE_ID_REQUEST",
  FETCH_RULES_BY_DEVICE_ID_SUCCESS: "FETCH_RULES_BY_DEVICE_ID_SUCCESS",
  RULES_LIST_REQUEST: "RULES_LIST_REQUEST",
  RULES_LIST_SUCCESS: "RULES_LIST_SUCCESS",
  RULES_LIST_FAILURE: "RULES_LIST_FAILURE",
  SHOW_INVITE_USER_MODAL: "SHOW_INVITE_USER_MODAL",
  RESET_RULE_VALUES: "RESET_RULE_VALUES",
  FETCH_BILLING_ACCOUNTS: "FETCH_BILLING_ACCOUNTS",
  SET_BILLING_ACCOUNTS: "SET_BILLING_ACCOUNTS",
  RESET_ALL_RULES: "RESET_ALL_RULES",
  UPDATE_TABLE_FILTER_STATE: "UPDATE_TABLE_FILTER_STATE",
  RESET_TABLE_FILTER_STATE: "RESET_TABLE_FILTER_STATE",
  SET_PAGINATION_NAV_SOURCE: "SET_PAGINATION_NAV_SOURCE",
  CLEAR_PAGINATION_NAV_SOURCE: "CLEAR_PAGINATION_NAV_SOURCE",
  CV_APP_ROI: "CV_APP_ROI",
  CV_APP_ROI_LOADING: "CV_APP_ROI_LOADING",
  UPDATE_CV_APP_ROI: "UPDATE_CV_APP_ROI",
  CREATE_RULE: "CREATE_RULE",
  RULE_SUCCESS_RESPONSE: "RULE_SUCCESS_RESPONSE",
  SET_COMPANION_LIST: "SET_COMPANION_LIST",
  UPDATE_WIDGET_CONFIG: "UPDATE_WIDGET_CONFIG",
  PATCH_WIDGET_CONFIG: "PATCH_WIDGET_CONFIG",
  SELECTED_TIMER_DATA: "SELECTED_TIMER_DATA",
  FORBIDDEN_ERROR_OCCURRED: "FORBIDDEN_ERROR_OCCURRED",
  CLEAR_ERROR_MESSAGE: "CLEAR_ERROR_MESSAGE",
  CAMERA_UPDATED_DATE: "CAMERA_UPDATED_DATE",
  SELECTED_CAMERA_INFO: "SELECTED_CAMERA_INFO",
  DISCOVERED_UPDATED_DATE: "DISCOVERED_UPDATED_DATE",
  SHOW_NOTIFICATION_BANNER: "SHOW_NOTIFICATION_BANNER",
  SHOW_CALIBRATION_BANNER: "SHOW_CALIBRATION_BANNER",
  UPDATE_CAMERA_UPDATED_LIST: "CAMERA_UPDATED_LIST",
  UPDATE_FOV_UPDATED_LIST: "FOV_UPDATED_LIST",
  TAG_ROI_SUCCESS_RESPONSE: "TAG_ROI_SUCCESS_RESPONSE",
  ROI_ADD_TAG_SUCCESS_RESPONSE: "ROI_ADD_TAG_SUCCESS_RESPONSE",
  UPDATE_ROILIST: "UPDATE_ROILIST",
  FETCH_BILLING_ACCOUNTS_LICENSES: "FETCH_BILLING_ACCOUNTS_LICENSES",
  FETCH_LICENSES_OF_ACCOUNT: "FETCH_LICENSES_OF_ACCOUNT",
  FETCH_LICENSES_OF_ACCOUNT_BY_ID: "FETCH_LICENSES_OF_ACCOUNT_BY_ID",
  CHANGE_LICENSE_TYPE: "CHANGE_LICENSE_TYPE",
  SET_ERROR: "SET_ERROR",
  SET_LICENSE_FORBIDDEN_ERROR: "SET_LICENSE_FORBIDDEN_ERROR",
  ADD_NEW_CITY: "ADD_NEW_CITY",
  ADD_NEW_STATE: "ADD_NEW_STATE",
  SHOW_LOGOUT_IDLE_MODAL: "SHOW_LOGOUT_IDLE_MODAL",
  HIDE_LOGOUT_IDLE_MODAL: "HIDE_LOGOUT_IDLE_MODAL",
  RESET_APP: "RESET_APP",
  SAVE_FLOOR_IMAGE: "SAVE_FLOOR_IMAGE",
  DELETE_FLOOR_IMAGE: "DELETE_FLOOR_IMAGE",
  SAVE_UNPAIREDCAM_IMAGE: "SAVE_UNPAIREDCAM_IMAGE",
  SAVE_STREAM_IMAGE: "SAVE_STREAM_IMAGE",
  SAVE_HS_ENTITY_IMAGE: "SAVE_HS_ENTITY_IMAGE",
  SAVE_EVIDENCE_IMAGE: "SAVE_EVIDENCE_IMAGE",
  SAVE_EVIDENCE_VIDEO_URL: "SAVE_EVIDENCE_VIDEO_URL",
  UPDATE_BUILDINGS: "UPDATE_BUILDINGS",
  REMOVE_BUILDING: "REMOVE_BUILDING",
  ROI_FAIL_RESPONSE: "ROI_FAIL_RESPONSE",
  UPDATE_CAMPUS_DETAILS: "UPDATE_CAMPUS_DETAILS",
  UPDATE_CAMPUS_DETAILS_REQUEST: "UPDATE_CAMPUS_DETAILS_REQUEST",
  GET_DISCOVERED_CAMERAS_FOR_COMP: "GET_DISCOVERED_CAMERAS_FOR_COMP",
  ERROR_LOG_UPLOAD: "ERROR_LOG_UPLOAD",
  FETCH_COMPANION_LIST_BY_CAMERA_REQUEST: "FETCH_COMPANION_LIST_BY_CAMERA_REQUEST",
  FETCH_COMPANION_LIST_BY_CAMERA_SUCCESS: "FETCH_COMPANION_LIST_BY_CAMERA_SUCCESS",
  FETCH_COMPANION_LIST_BY_CAMERA_FAILURE: "FETCH_COMPANION_LIST_BY_CAMERA_FAILURE",
  FETCH_COMPANION: "FETCH_COMPANION",
  SET_CAMERA_QR: "SET_CAMERA_QR",
  GET_FOVIDS: "GET_FOVIDS",
  FETCH_SITE: "FETCH_SITE",
  FETCH_FLOOR: "FETCH_FLOOR",
  FETCH_AREA: "FETCH_AREA",
  FETCH_SUBAREA: "FETCH_SUBAREA",
  CLEAR_ONBOARDING_FIELDS: "CLEAR_ONBOARDING_FIELDS",
  SET_SELECTED_COMPANION_FOV_STREAM_COUNTS: "SET_SELECTED_COMPANION_FOV_STREAM_COUNTS",
  ADD_MANUAL_CAMERA_REQUEST: "ADD_MANUAL_CAMERA_REQUEST",
  ADD_MANUAL_CAMERA_SUCCESS: "ADD_MANUAL_CAMERA_SUCCESS",
  ADD_MANUAL_CAMERA_FAILURE: "ADD_MANUAL_CAMERA_FAILURE",
  SELECT_ENCODES: "SELECT_ENCODES",
  ADD_MANUAL_CAMERA_SUCCESS_RES: "ADD_MANUAL_CAMERA_SUCCESS_RES",
  ADD_RTSP_URL: "ADD_RTSP_URL",
  DISABLE_NEXT_BUTTON: "DISABLE_NEXT_BUTTON",
  MODAL_OPEN: "MODAL_OPEN",
  PAIRING_STATUS: "PAIRING_STATUS",
  REFRESH_CAMERA_PAGE: "REFRESH_CAMERA_PAGE",
  UPDATE_CAMERA_ON_BOARED_REQ: "UPDATE_CAMERA_ON_BOARED_REQ",
  UPDATE_CAMERA_ON_BOARED_DETAILS: "UPDATE_CAMERA_ON_BOARED_DETAILS",
  FETCH_CRITICAL_UNRESOLVED_EVENTS_REQUEST: "FETCH_CRITICAL_UNRESOLVED_EVENTS_REQUEST",
  FETCH_CRITICAL_UNRESOLVED_EVENTS_SUCCESS: "FETCH_CRITICAL_UNRESOLVED_EVENTS_SUCCESS",
  FETCH_CRITICAL_UNRESOLVED_EVENTS_FAILURE: "FETCH_CRITICAL_UNRESOLVED_EVENTS_FAILURE",
  SET_IS_VALID: "SET_IS_VALID",
  SET_IS_ERROR: "SET_IS_ERROR",
  SET_USER_NAME: "SET_USER_NAME",
  SET_PASSWORD: "SET_PASSWORD",
  SET_HOST_NAME: "SET_HOST_NAME",
  SET_PORT_NAME: "SET_PORT_NAME",
  SET_MANUAL_API_RESPONSE: "SET_MANUAL_API_RESPONSE",
  SET_CALIBRATING: "SET_CALIBRATING",
  TRIGGER_UNPAIRED_CAMERAS_REFRESH: "TRIGGER_UNPAIRED_CAMERAS_REFRESH",
  RESET_UNPAIRED_CAMERAS_REFRESH: "RESET_UNPAIRED_CAMERAS_REFRESH",
  CHANGE_LICENSE_TYPE_SUCCESS: "CHANGE_LICENSE_TYPE_SUCCESS",
  CHANGE_LICENSE_TYPE_FAILURE: "CHANGE_LICENSE_TYPE_FAILURE",
  CAMERA_CALIBRATION_UPDATE_STATUS: "CAMERA_CALIBRATION_UPDATE_STATUS",
  FETCH_RULES_WITHOUT_ROI_REQUEST: "FETCH_RULES_WITHOUT_ROI_REQUEST",
  FETCH_RULES_SUCCESS: "FETCH_RULES_SUCCESS",
  FETCH_APPEARANCES_SUCCESS: "FETCH_APPEARANCES_SUCCESS",
  SET_ADVANCED_CONFIG_APPEARANCES: "SET_ADVANCED_CONFIG_APPEARANCES",
  CLEAR_ADVANCED_CONFIG_APPEARANCES: "CLEAR_ADVANCED_CONFIG_APPEARANCES",
  SET_ADVANCED_CONFIG_THRESHOLDS: "SET_ADVANCED_CONFIG_THRESHOLDS",
  SET_ADVANCED_CONFIG_RADIO: "SET_ADVANCED_CONFIG_RADIO",
  DOWNLOAD_APPEARANCE_IMAGES_SUCCESS: "DOWNLOAD_APPEARANCE_IMAGES_SUCCESS",
  APPEND_EVENT: "APPEND_EVENT",
  APPEND_EVENT_SUCCESS: "APPEND_EVENT_SUCCESS",
  FETCHED_FORENSIC_SEARCH_RESULTS: "FETCHED_FORENSIC_SEARCH_RESULTS",
  GET_RECENT_FORENSIC_SEARCHES_REQUEST: "GET_RECENT_FORENSIC_SEARCHES_REQUEST",
  CREATE_FORENSIC_SEARCH_RESULTS: "CREATE_FORENSIC_SEARCH_RESULTS",
  DELETE_FORENSIC_SEARCH_RESULTS: "DELETE_FORENSIC_SEARCH_RESULTS",
  GET_IMAGE_URL_FORENSIC_SEARCH_IMAGE_INDEX: "GET_IMAGE_URL_FORENSIC_SEARCH_IMAGE_INDEX",
  GET_IMAGE_URL_FORENSIC_SEARCH_IMAGE_INDEX_RESPONSE : "GET_IMAGE_URL_FORENSIC_SEARCH_IMAGE_INDEX_RESPONSE",
  CREATE_FORENSIC_SEARCH_RESPONSE: "CREATE_FORENSIC_SEARCH_RESPONSE",
  DELETE_FORENSIC_SEARCH_RESPONSE: "DELETE_FORENSIC_SEARCH_RESPONSE",
  GET_FORENSIC_SEARCH_STATUS_REQUEST: "GET_FORENSIC_SEARCH_STATUS_REQUEST",
  GET_FORENSIC_SEARCH_STATUS_RESPONSE: "GET_FORENSIC_SEARCH_STATUS_RESPONSE",
  UPDATE_FORENSIC_SEARCH_IMAGES_RESPONSE: "UPDATE_FORENSIC_SEARCH_IMAGES_RESPONSE",
  APPEND_EVENT_SUCCESS: "APPEND_EVENT_SUCCESS",
  SELECTED_CAMERA_UPDATED: "SELECTED_CAMERA_UPDATED",
  SAVE_EXPANDED_EVENT: "SAVE_EXPANDED_EVENT",
  CLEAR_EXPANDED_EVENT: "CLEAR_EXPANDED_EVENT",
  FETCH_INCIDENTS_BY_FLOOR_REQUEST: "FETCH_INCIDENTS_BY_FLOOR_REQUEST",
  FETCH_INCIDENTS_BY_FLOOR_SUCCESS: "FETCH_INCIDENTS_BY_FLOOR_SUCCESS",
  FETCH_INCIDENTS_BY_FLOOR_FAILURE: "FETCH_INCIDENTS_BY_FLOOR_FAILURE",
  SET_SITE_STATS_CACHE: "SET_SITE_STATS_CACHE",
  SET_SITE_STATS_PENDING: "SET_SITE_STATS_PENDING",
  CHECK_RESOLVE_STATUS_REQUEST: "CHECK_RESOLVE_STATUS_REQUEST",
  CHECK_RESOLVE_STATUS_SUCCESS: "CHECK_RESOLVE_STATUS_SUCCESS",
  CHECK_RESOLVE_STATUS_FAILURE: "CHECK_RESOLVE_STATUS_FAILURE",
  START_RESOLVE_STATUS_POLLING: "START_RESOLVE_STATUS_POLLING",
  STOP_RESOLVE_STATUS_POLLING: "STOP_RESOLVE_STATUS_POLLING",
  SET_USER_MANAGEMENT_USERS: "SET_USER_MANAGEMENT_USERS",
  SET_USER_MANAGEMENT_GROUPS: "SET_USER_MANAGEMENT_GROUPS",
  SET_USER_MANAGEMENT_PENDING_INVITES: "SET_USER_MANAGEMENT_PENDING_INVITES",
  SET_ROI_LIST_WITH_CVAPPS_LOADING_STATUS: "SET_ROI_LIST_WITH_CVAPPS_LOADING_STATUS",
  UPDATE_SITE_TAG_LIST_ITEM: "UPDATE_SITE_TAG_LIST_ITEM",
  SET_SELECTED_SITE_ID: "SET_SELECTED_SITE_ID",
  SET_STATISTICS_SELECTION: "SET_STATISTICS_SELECTION",
  CLEAR_STATISTICS_SELECTION: "CLEAR_STATISTICS_SELECTION",
};
export const ROI_LIST_WITH_CVAPPS_LOADING_STATUS = {
  NotLoaded: "NotLoaded",
  Loading: "Loading",
  Loaded: "Loaded",
  LoadingFailed: "LoadingFailed",
};

export const setRoiListWithCvAppsLoadingStatus = (status) => ({
  type: types.SET_ROI_LIST_WITH_CVAPPS_LOADING_STATUS,
  payload: status,
});

export const addIncidentList = (list) => {
  return {
    type: types.ADD_AVAILABLE_INCIDENTS,
    payload: list
  };
};

export const addSelectedIncident = (incident) => {
  return {
    type: types.ADD_SELECTED_AVAILABLE_INCIDENT,
    payload: incident
  };
};

export const addBulkSelectedIncidents = (incidents) => {
  return {
    type: types.ADD_BULK_SELECTED_AVAILABLE_INCIDENTS,
    payload: incidents
  };
};

export const removeBulkSelectedIncidents = () => {
  return {
    type: types.REMOVE_BULK_SELECTED_AVAILABLE_INCIDENTS
  };
};

export const removeSelectedIncident = (incident) => {
  return {
    type: types.REMOVE_SELECTED_AVAILABLE_INCIDENT,
    payload: incident
  };
};

export const addLastUpdatedTime = (timeStamp) => {
  return {
    type: types.ADD_LAST_UPDATED_TIME,
    payload: timeStamp
  };
};

export const userRoleAction = (role) => {
  return {
    type: types.USER_ROLE,
    payload: role
  };
};

export const userRoleList = (userRoleList) => {
  return {
    type: types.USER_ROLE_LIST,
    userRoleList
  };
};

export const roleList = (roleList) => {
  return {
    type: types.ROLE_LIST,
    roleList
  };
};

export const devicesSelectedTab = (devicesSelected) => {
  return {
    type: types.DEVICES_SELECTED_DATA,
    devicesSelected
  };
};

export const sitesModified = (bool) => {
  return {
    type: types.SITES_MODIFIED,
    payload: bool
  };
};

export const eventSettings = (settings) => {
  return {
    type: types.EVENT_SETTINGS,
    payload: settings
  };
};

export const eventPageNumber = (pageNumber) => {
  return {
    type: types.EVENT_PAGENUMBER,
    payload: pageNumber
  };
};

export const updateBaselineInfo = (info) => {
  return {
    type: types.UPDATE_BASELINE_INFO,
    payload: info
  };
};

export const showNotificationBanner = (bannerInfo) => {
  return {
    type: types.SHOW_NOTIFICATION_BANNER,
    bannerInfo
  };
};

export const showCalibrationBanner = (bannerInfo) => {
  return {
    type: types.SHOW_CALIBRATION_BANNER,
    bannerInfo
  };
};

export const updateResetTime = (time) => {
  return {
    type: types.UPDATE_RESET_TIME,
    time
  };
};

export const activateSensor = (sensors, callback) => {
  return {
    type: types.ACTIVATE_SENSOR,
    sensors,
    callback
  };
};

export const setShowSensorActivateModal = (modalState, callback) => {
  return {
    type: types.SET_SHOW_SENSOR_ACTIVATE_MODAL,
    modalState,
    callback
  };
};

export const setCameraUpdatedDate = (date) => {
  return {
    type: types.CAMERA_UPDATED_DATE,
    date
  };
};

export const setDiscoveredUpdatedDate = (date) => {
  return {
    type: types.DISCOVERED_UPDATED_DATE,
    date
  };
};

export const fetchedCameraDevices = (cameraDeviceList) => {
  return {
    type: types.FETCHED_CAMERA_DEVICES,
    cameraDeviceList
  };
};
export const eventMouseOur = (id, evidence) => {
  return {
    type: types.SET_SOURCE_ID,
    id,
    evidence
  };
};
export const setRoiPolygon = (roiData) => {
  return {
    type: types.SET_ROI_POLYGON,
    roiData
  };
};
export const setRoiListWithCvApps = (roiList) => {
  return {
    type: types.SET_ROI_LIST_WITH_CVAPPS,
    roiList
  };
};
export const setStatistic = (statisticData) => {
  return {
    type: types.SET_STATISTICS,
    statisticData
  };
};

export const cvAppRoi = (roiData) => {
  return {
    type: types.CV_APP_ROI,
    payload: roiData
  };
};

export const setCvAppRoiLoading = (loading) => {
  return {
    type: types.CV_APP_ROI_LOADING,
    payload: loading,
  };
};

export const updateCvAppRoi = (roiData) => {
  return {
    type: types.UPDATE_CV_APP_ROI,
    payload: roiData
  };
};

export const createRule = (ruleData, roiId) => {
  return {
    type: types.CREATE_RULE,
    ruleData,
    roiId
  };
};
export const successCreateRule = (ruleResponse) => {
  return {
    type: types.RULE_SUCCESS_RESPONSE,
    ruleResponse
  };
};
export const createRoiRequest = (payloadData) => {
  return {
    type: types.CREATE_ROI_REQUEST,
    payload: payloadData
  };
};

export const successCreateRoi = (roiResponse) => {
  return {
    type: types.ROI_SUCCESS_RESPONSE,
    roiResponse
  };
};
export const FailureCreateRoi = (roiError) => {
  return {
    type: types.ROI_FAIL_RESPONSE,
    roiError
  };
};
export const successAddTagsToRoi = (roiResponse) => {
  return {
    type: types.ROI_ADD_TAG_SUCCESS_RESPONSE,
    roiResponse
  };
};

export const successTagRoiResponse = (taggedRoiResponse) => {
  return {
    type: types.TAG_ROI_SUCCESS_RESPONSE,
    taggedRoiResponse
  };
};

export const successUpdateRoi = (roiResponse) => {
  return {
    type: types.ROI_UPDATE_SUCCESS_RESPONSE,
    roiResponse
  };
};

export const successDeleteRoi = (roiResponse) => {
  return {
    type: types.ROI_DELETE_SUCCESS_RESPONSE,
    roiResponse
  };
};

export const deleteRoiRequest = (payloadData) => {
  return {
    type: types.DELETE_ROI_REQUEST,
    payload: payloadData
  };
};
export const unsubscribeObjectBlurringRoiRequest = (payloadData, cvappname) => {
  return {
    type: types.UNSUBSCRIBE_ROI_OF_OBJECTBLURRING,
    payload: payloadData,
    cvappname
  };
};
export const deleteBulkUnsubscribeRoiRequest = (payloadData) => {
  return {
    type: types.DELETE_BULK_UNSUBSCRIBE_ROI_REQUEST,
    payload: payloadData
  };
};

export const editRoiRequest = (payloadData) => {
  return {
    type: types.EDIT_ROI_REQUEST,
    payload: payloadData
  };
};
export const resetRoi = () => {
  return {
    type: types.RESET_ROI
  };
};

export const addTags = (roiId, tags, siteId, selectedTagIds ) => {
  return {
    type: types.ADD_STATISTICS,
    roiId,
    tags,
    siteId,
    selectedTagIds
  };
};

export const fetchAllDevices = () => {
  return {
    type: types.FETCH_ALL_DEVICES
  };
};

export const getAllCompanionDevices = () => {
  return {
    type: types.FETCH_ALL_COMPANION_DEVICES
  };
};
export const getAllCameraAndFovsDevices = (resolve) => {
  return {
    type: types.FETCH_ALL_CAMERA_AND_FOVS_DEVICES,
    ...(resolve && { meta: { resolve } })
  };
};

export const fetchDiscoveredCamerasRequest = (payload) => ({
  type: types.FETCH_DISCOVERED_CAMERAS_REQUEST,
  payload,
});

export const getCameraCredsRequest = (payload) => ({
  type: types.GET_CAMERA_CREDS_REQUEST,
  payload
});

export const getCameraCredsSuccess = (response) => ({
  type: types.GET_CAMERA_CREDS_SUCCESS,
  payload: response
});

export const getCameraCredsFailure = (error) => ({
  type: types.GET_CAMERA_CREDS_FAILURE,
  payload: error
});

export const resetCameraCreds = () => ({
  type: types.RESET_CAMERA_CREDS
});

export const fetchedUnPairedCameraDevices = (discoveredCamerasList) => {
  return {
    type: types.FETCHED_UN_PAIRED_CAMERA_DEVICES,
    discoveredCamerasList
  };
};

export const updateDevices = (devices) => {
  return {
    type: types.UPDATE_ALL_DEVICES,
    devices
  };
};

export const removeCameraFromList = (cameraId) => ({
  type: types.REMOVE_CAMERA_FROM_LIST,
  cameraId,
});

export const fetchCameraName = (selectedCamera) => {
  return {
    type: types.FETCH_CAMERA_NAME,
    selectedCamera
  };
};

export const setSelectedCameraInfo = (cameraInfo) => {
  return {
    type: types.SELECTED_CAMERA_INFO,
    cameraInfo
  };
};

export const startEventPolling = () => {
  return {
    type: types.START_POLLING_FOR_EVENTS
  };
};

export const stopEventPolling = () => {
  return {
    type: types.STOP_POLLING_FOR_EVENTS
  };
};

export const startReportsPolling = () => {
  return {
    type: types.START_POLLING_FOR_REPORTS
  };
};

export const setNetTrafficFlowInterval = (intervalInSec) => {
  return {
    type: types.NET_TRAFFIC_FLOW_INTERVAL,
    intervalInSec
  };
};

export const stopReportsPolling = () => {
  return {
    type: types.STOP_POLLING_FOR_REPORTS
  };
};

export const fetchTags = () => {
  return {
    type: types.FETCH_TAGS
  };
};

export const fetchedTags = (tagData) => {
  return {
    type: types.FETCHED_TAGS,
    tagData
  };
};

export const fetchAllTags = () => {
  return {
    type: types.FETCH_ALL_TAGS
  };
};

export const fetchedAllTags = (tagData) => {
  return {
    type: types.FETCHED_ALL_TAGS,
    tagData
  };
};

export const fetchAllSites = () => {
  return {
    type: types.FETCH_ALL_SITES
  };
};

export const fetchedAllSites = (tagData) => {
  return {
    type: types.FETCHED_ALL_SITES,
    tagData
  };
};

export const updateAreaTags = (tagData) => {
  return {
    type: types.UPDATE_AREA_TAGS,
    tagData
  };
};

export const updateReportsPolling = (value) => {
  return {
    type: types.UPDATE_REPORT_POLLING,
    value
  };
};

export const fetchedReports = (reportData) => {
  return {
    type: types.FETCHED_REPORTS,
    payload: reportData
  };
};

export const fetchedEvents = (eventData, ceMap) => {
  return {
    type: types.FETCHED_EVENTS,
    eventData,
    ceMap
  };
};

export const fetchDataToPlotGraph = (payload) => {
  return {
    type: types.FETCH_GRAPH_DATA,
    payload
  };
};

export const fetchedCountStart = (count) => {
  return {
    type: types.FETCHED_COUNTER_COUNT,
    count
  };
};

export const fetchCounterCount = (payload) => {
  return {
    type: types.FETCH_COUNTER_COUNT,
    payload
  };
};

export const fetchExitDataToPlotGraph = (payload) => {
  return {
    type: types.FETCH_EXIT_GRAPH_DATA,
    payload
  };
};

export const fetchCameraDataToPlotGraph = (payload) => {
  return {
    type: types.FETCH_CAMERA_GRAPH_DATA,
    payload
  };
};

export const fetchedCameraDataToPlotGraph = (cameraGraphData) => {
  return {
    type: types.FETCHED_CAM_GRAPH_DATA,
    cameraGraphData
  };
};

export const fetchedDataToPlotGraph = (graphData) => {
  return {
    type: types.FETCHED_GRAPH_DATA,
    graphData
  };
};

export const fetchedExitDataToPlotGraph = (exitGraphData) => {
  return {
    type: types.FETCHED_EXIT_GRAPH_DATA,
    exitGraphData
  };
};

export const getReportDetails = (payload) => {
  return {
    type: types.FETCH_REPORT_DETAILS,
    payload
  };
};

export const fetchedReportDetails = (reportDetails) => {
  return {
    type: types.FETCHED_REPORT_DETAILS,
    reportDetails
  };
};

export const apiError = (value) => {
  return {
    type: types.API_ERROR,
    value
  };
};

export const setDefaultAPIError = () => {
  return {
    type: types.DEFAULT_API_ERROR
  };
};

export const setRoleError = (message) => ({
  type: types.SET_ROLE_ERROR,
  payload: message,
});

export const setRole = (userRole) => {
  return {
    type: types.SET_USER_ROLE,
    role: userRole
  };
};
export const assignRole = (userRole) => {
  return {
    type: types.ASSIGN_USER_ROLE,
    role: userRole
  };
};

export const setDropdownValue = (value) => {
  return {
    type: types.SET_DROPDOWN_VALUE,
    payload: value
  };
};

export const setFirstName = (firstName) => ({
  type: types.SET_FIRST_NAME,
  payload: firstName
});

export const setLastName = (lastName) => ({
  type: types.SET_LAST_NAME,
  payload: lastName
});

export const setPhoneNumber = (phoneNumber) => ({
  type: types.SET_PHONE_NUMBER,
  payload: phoneNumber
});

export const setEmail = (email) => ({
  type: types.SET_EMAIL,
  payload: email
});

export const updateCheckedSites = (checkedSites) => ({
  type: types.UPDATE_CHECKED_SITES,
  payload: checkedSites
});

export const updateSelectedGroups = (selectedGroups) => ({
  type: types.UPDATE_SELECTED_GROUPS,
  payload: selectedGroups
});

export const updateInviteUserData = (userData) => {
  return {
    type: types.UPDATE_INVITE_USER_DATA,
    payload: userData
  };
};

export const setSelecedCompanion = (value) => {
  return {
    type: types.COMPANION_SELECTED,
    value
  };
};

export const setFloorSelected = (value) => {
  return {
    type: types.FLOOR_SELECTED,
    value
  };
};

export const setCameraName = (value) => {
  return {
    type: types.CAMERA_UPDATED,
    value
  };
};

export const setAreaSelected = (value) => {
  return {
    type: types.AREA_SELECTED,
    value
  };
};

export const getSiteSelected = (value) => {
  return {
    type: types.SITE_SELECTED,
    value
  };
};

export const getFloorAreas = (value) => {
  return {
    type: types.FLOOR_AREAS,
    value
  };
};

export const getFovNames = (value) => {
  return {
    type: types.GET_FOVNAMES,
    value
  };
};

export const setGroupName = (groupName) => ({
  type: types.SET_GROUP_NAME,
  payload: groupName
});

export const setCheckedSites = (checkedSites) => ({
  type: types.SET_CHECKED_SITES,
  payload: checkedSites
});

export const setSelectedMembers = (selectedMembers) => ({
  type: types.SET_SELECTED_MEMBERS,
  payload: selectedMembers
});

export const setUserActiveSession = (activeSession) => {
  return {
    type: types.SET_ACTIVE_SESSION,
    payload: activeSession
  };
};

export const updateUserActiveSessionDelta = (activeSession) => {
  return {
    type: types.UPDATE_ACTIVE_SESSION_DELTA,
    payload: activeSession
  };
};

export const setLoading = (loading) => ({
  type: types.SET_LOADING,
  payload: loading
});

export const siteTagListUpdated = (payload) => ({
  type: types.UPDATED_SITE_TAG_LIST,
  payload
});

export const putProcessedSiteTagList = (payload) => ({
  type: types.PROCESS_NESTED_SITE_TAG_LIST,
  payload
});
export const setAllTagList = (payload) => ({
  type: types.SETALLTAGLIST,
  payload
});

export const setAllBaselineCount = (payload) => ({
  type: types.SET_ALL_BASELINEDATA,
  payload
});

export const setStatisticsSelection = (payload) => ({
  type: types.SET_STATISTICS_SELECTION,
  payload
});

export const clearStatisticsSelection = () => ({
  type: types.CLEAR_STATISTICS_SELECTION
});

export const addNewArea = (payload) => ({
  type: types.ADD_NEW_AREA,
  payload
});

export const addNewSubArea = (payload) => ({
  type: types.ADD_NEW_SUBAREA,
  payload
});

export const fetchCountryIdsRequest = (resolve, force = false, showLoader = false) => {
  return {
    type: types.FETCH_COUNTRY_IDS_REQUEST,
    force,
    showLoader,
    ...(resolve && { meta: { resolve } })
  };
};

export const fetchCountryIdsSuccess = (countryData) => ({
  type: types.FETCH_COUNTRY_IDS_SUCCESS,
  payload: countryData
});

export const fetchCountryIdsFailure = (error) => ({
  type: types.FETCH_COUNTRY_IDS_FAILURE,
  payload: error
});

// export const fetchSitesRequest = () => ({
//   type: types.FETCH_SITES_REQUEST,
// });

export const fetchSitesSuccess = (sites) => ({
  type: types.FETCH_SITES_SUCCESS,
  payload: sites
});

export const fetchSitesFailure = (error) => ({
  type: types.FETCH_SITES_FAILURE,
  payload: error
});

export const deleteSiteRequest = (siteId) => ({
  type: types.DELETE_SITE_REQUEST,
  payload: siteId
});

export const deleteSiteSuccess = () => ({
  type: types.DELETE_SITE_SUCCESS
});

export const deleteSiteFailure = (error) => ({
  type: types.DELETE_SITE_FAILURE,
  payload: error
});

export const setCombinedCountryTagData = (combinedResponse) => ({
  type: types.SET_COMBINED_COUNTRY_TAGDATA,
  payload: combinedResponse
});

export const setCombinedSitesTagData = (combinedResponse) => ({
  type: types.SET_COMBINED_SITES_TAGDATA,
  payload: combinedResponse
});

export const fetchCVApp = () => ({
  type: types.FETCH_CV_APP
});

export const errorLogUpload = (payload) => {
  return {
    type: types.ERROR_LOG_UPLOAD,
    payload
  };
};

export const fetchedCVApp = (cvAppList) => ({
  type: types.FETCHED_CV_APP,
  payload: cvAppList
});

export const getAllEvents = (sites) => {
  return {
    type: types.GET_EVENTS,
    payload: sites
  };
};

export const appendEvent = (eventData, ceMap = {}) => {
  return {
    type: types.APPEND_EVENT,
    eventData,
    ceMap
  };
};

export const appendEventSuccess = (eventData, ceMap = {}) => ({
  type: types.APPEND_EVENT_SUCCESS,
  eventData,
  ceMap
});

export const getAllRoiListWithCvApps = () => {
  return {
    type: types.GET_ALL_ROILIST_WITH_CVAPPS
  };
};

export const setCamBlurValue = (value) => {
  return {
    type: types.CAM_BLUR_VALUE,
    value
  };
};

export const resetOnboardingCamera = () => {
  console.log("Resetting onboarding camera");
  return {
    type: types.RESET_ONBOARD_CAMERA
  };
};

export const setCamDetails = (value) => {
  return {
    type: types.SET_CAM_DETAILS,
    value
  };
};

export const setSelectedCamQR = (value) => {
  return {
    type: types.SET_CAM_QR,
    value
  };
};

export const setGroupDetails = (groupDetails) => ({
  type: types.SET_GROUP_DETAILS,
  payload: groupDetails
});

export const fetchedCompanionDevices = (companionDeviceList) => {
  return {
    type: types.FETCHED_COMPANION_DEVICES,
    companionDeviceList
  };
};

export const updateCompanionDeviceSite = (companionDeviceList) => {
  return {
    type: types.UPDATE_COMPANION_DEVICE_SITE,
    companionDeviceList
  };
};

export const updateRoiList = (roiList) => {
  return {
    type: types.UPDATE_ROILIST,
    roiList
  };
};

export const setUnpairedCamDetails = (value) => {
  return {
    type: types.SET_UNPAIRED_CAM_DETAILS,
    value
  };
};

export const setCamPosition = (value) => {
  return {
    type: types.SET_CAM_POSITION,
    value
  };
};

export const eventError = (value) => {
  return {
    type: types.EVENT_ERROR,
    value
  };
};

export const updateSelectedLeftNav = (payload) => {
  return {
    type: types.UPDATE_SELECTED_LEFT_NAV,
    payload
  };
};

export const updateRuleValue = (payload) => {
  return {
    type: types.UPDATE_RULE_VALUES,
    payload: Array.isArray(payload) ? payload : [payload]
  };
};

export const resetRuleValue = (payload) => {
  return {
    type: types.RESET_RULE_VALUES,
    payload
  };
};

export const updateTableFilterState = (payload) => {
  return {
    type: types.UPDATE_TABLE_FILTER_STATE,
    payload
  };
};

export const resetTableFilterState = (payload) => {
  return {
    type: types.RESET_TABLE_FILTER_STATE,
    payload
  };
};

export const setPaginationNavSource = (pageIdentifier) => ({
  type: types.SET_PAGINATION_NAV_SOURCE,
  payload: pageIdentifier
});

export const clearPaginationNavSource = () => ({
  type: types.CLEAR_PAGINATION_NAV_SOURCE
});

export const loadingEvents = (value) => {
  return {
    type: types.LOADING_EVENTS,
    value
  };
};

export const fetchRulesByDeviceIdRequest = (payload) => ({
  type: types.FETCH_RULES_BY_DEVICE_ID_REQUEST,
  payload: payload
});

export const fetchRulesWithRoiSuccess = (payload) => ({
  type: types.FETCH_RULES_WITH_ROI_SUCCESS,
  payload: payload
});

export const fetchRulesWithoutRoiRequest = (payload) => ({
  type: types.FETCH_RULES_WITHOUT_ROI_REQUEST,
  payload: payload
});

export const fetchRulesSuccess = (response) => ({
  type: types.FETCH_RULES_SUCCESS,
  response
});

export const fetchRulesByDeviceIdSuccess = (response) => ({
  type: types.FETCH_RULES_BY_DEVICE_ID_SUCCESS,
  response
});

export const fetchRulesListRequest = (payload) => ({
  type: types.RULES_LIST_REQUEST,
  payload
});

export const fetchRulesListSuccess = (response) => ({
  type: types.RULES_LIST_SUCCESS,
  response
});

export const fetchRulesListFailure = (error) => ({
  type: types.RULES_LIST_FAILURE,
  error
});

export const setShowInviteUserModal = (isVisible) => ({
  type: types.SHOW_INVITE_USER_MODAL,
  payload: isVisible
});

export const fetchBillingAccounts = () => ({
  type: types.FETCH_BILLING_ACCOUNTS
});

export const setBillingAccounts = (billingAccounts) => ({
  type: types.SET_BILLING_ACCOUNTS,
  billingAccounts
});

export const resetAllRule = () => {
  return {
    type: types.RESET_ALL_RULES
  };
};

export const setCompanionList = (value) => {
  return {
    type: types.SET_COMPANION_LIST,
    value
  };
};

export const updateWidgetConfig = (widgetConfig) => {
  return {
    type: types.UPDATE_WIDGET_CONFIG,
    payload: widgetConfig
  };
};

export const patchWidgetConfig = (widgetConfig) => {
  return {
    type: types.PATCH_WIDGET_CONFIG,
    payload: widgetConfig
  };
};
export const selectedTimerData = (timerValue) => {
  return {
    type: types.SELECTED_TIMER_DATA,
    timerValue
  };
};
export const forbiddenErrorOccurred = (message) => ({
  type: types.FORBIDDEN_ERROR_OCCURRED,
  payload: message
});

export const clearErrorMessage = () => ({
  type: types.CLEAR_ERROR_MESSAGE
});
export const updateDeviceCameraList = (cameraList) => ({
  type: types.UPDATE_CAMERA_UPDATED_LIST,
  cameraList
});
export const updateDeviceFovList = (fovList) => ({
  type: types.UPDATE_FOV_UPDATED_LIST,
  fovList
});
export const addNewCity = (newCity) => ({
  type: types.ADD_NEW_CITY,
  payload: newCity
});

export const addNewState = (newState) => ({
  type: types.ADD_NEW_STATE,
  payload: newState
});

export const updateBuilding = (filteredSites) => ({
  type: types.UPDATE_BUILDINGS,
  payload: filteredSites
});

export const changeLicenseType = (billingAccountId, deviceIdentifier, assignSKU, removeSKU, navigate, fovList, successTitle) => ({
  type: types.CHANGE_LICENSE_TYPE,
  payload: {
    billingAccountId,
    deviceIdentifier,
    assignSKU,
    removeSKU,
    navigate,
    fovList,
    successTitle
  }
});

export const changeLicenseTypeSuccess = (response) => ({
  type: types.CHANGE_LICENSE_TYPE_SUCCESS,
  payload: response
});

export const changeLicenseTypeFailure = (error) => ({
  type: types.CHANGE_LICENSE_TYPE_FAILURE,
  payload: error
});

export const setError = (error) => ({ type: types.SET_ERROR, payload: error });

export const setLicenseForbiddenError = (payload) => ({ type: types.SET_LICENSE_FORBIDDEN_ERROR, payload });

export const showModal = (message) => ({
  type: types.SHOW_LOGOUT_IDLE_MODAL,
  payload: message
});

export const hideModal = () => ({
  type: types.HIDE_LOGOUT_IDLE_MODAL
});

export const resetApp = () => ({
  type: types.RESET_APP
});
export const saveFloorImageMapping = (id, imageUrl) => ({
  type: types.SAVE_FLOOR_IMAGE,
  payload: { id, imageUrl }
});
export const deleteFloorImageMapping = (id) => ({
  type: types.DELETE_FLOOR_IMAGE,
  payload: { id }
});
export const saveStreamImageMapping = (id, imageUrl, timeStamp) => ({
  type: types.SAVE_STREAM_IMAGE,
  payload: { id, imageUrl, timeStamp }
});
export const saveHsEntityImageMapping = (id, imageUrl, timeStamp) => ({
  type: types.SAVE_HS_ENTITY_IMAGE,
  payload: { id, imageUrl, timeStamp }
});
export const saveUnpairedCameImageMapping = (id, imageUrl, timeStamp) => ({
  type: types.SAVE_UNPAIREDCAM_IMAGE,
  payload: { id, imageUrl, timeStamp }
});
export const saveEvidenceImage = (key, blobDataUrl) => ({
  type: types.SAVE_EVIDENCE_IMAGE,
  payload: { key, blobDataUrl }
});
export const saveEvidenceVideoUrl = (key, s3Url) => ({
  type: types.SAVE_EVIDENCE_VIDEO_URL,
  payload: { key, s3Url }
});

export const updateCampusDetails = (siteTagList) => ({
  type: types.UPDATE_CAMPUS_DETAILS,
  payload: siteTagList
});

export const updateCampusDetailsRequest = (payload) => ({
  type: types.UPDATE_CAMPUS_DETAILS_REQUEST,
  payload
});

export const getDiscoveredCamForComp = (payload) => ({
  type: types.GET_DISCOVERED_CAMERAS_FOR_COMP,
  payload
});

export const fetchCompanionListByCameraRequest = (activeSession, cameraQR) => ({
  type: types.FETCH_COMPANION_LIST_BY_CAMERA_REQUEST,
  payload: { activeSession, cameraQR }
});

export const fetchCompanionListByCameraSuccess = (companionList) => ({
  type: types.FETCH_COMPANION_LIST_BY_CAMERA_SUCCESS,
  payload: companionList
});

export const fetchCompanionListByCameraFailure = (error) => ({
  type: types.FETCH_COMPANION_LIST_BY_CAMERA_FAILURE,
  payload: error
});

export const fetchCompanion = (companionDevice) => ({
  type: types.FETCH_COMPANION,
  value: companionDevice
});

export const selectEncodes = (data) => {
  return { type: types.SELECT_ENCODES, value: data };
};

export const setSelectedCameraQR = (value) => {
  return {
    type: types.SET_CAMERA_QR,
    value
  };
};

export const getFovIds = (value) => {
  return {
    type: types.GET_FOVIDS,
    value
  };
};

export const fetchSite = (site) => ({
  type: types.FETCH_SITE,
  value: site
});

export const fetchFloor = (floor) => ({
  type: types.FETCH_FLOOR,
  value: floor
});

export const fetchArea = (area) => ({
  type: types.FETCH_AREA,
  value: area
});

export const fetchSubArea = (subarea) => ({
  type: types.FETCH_SUBAREA,
  value: subarea
});

export const clearOnboardingFields = (fields) => ({
  type: types.CLEAR_ONBOARDING_FIELDS,
  payload: fields // array of field names
});

export const setSelectedCompanionFovStreamCounts = (selectedCompanionFovStreamAvailabilityCount, selectedCompanionFovStreamCount) => ({
  type: types.SET_SELECTED_COMPANION_FOV_STREAM_COUNTS,
  payload: {
    selectedCompanionFovStreamAvailabilityCount,
    selectedCompanionFovStreamCount
  }
});
export const addManualCameraRequest = () => ({
  type: types.ADD_MANUAL_CAMERA_REQUEST
});

export const addManualCameraSuccess = (payload) => ({
  type: types.ADD_MANUAL_CAMERA_SUCCESS,
  payload
});

export const addManualCameraSuccessResponse = (payload) => {
  console.log("addManualCameraSuccessResponse", payload);
  return {
    type: types.ADD_MANUAL_CAMERA_SUCCESS_RES,
    payload
  };
};

export const updateCameraOnboaredReq = (payload) => ({
  type: types.UPDATE_CAMERA_ON_BOARED_REQ,
  payload
});

export const updateCameraOnboaredDetails = (payload) => ({
  type: types.UPDATE_CAMERA_ON_BOARED_DETAILS,
  payload
});

export const addManualCameraFailure = (payload) => ({
  type: types.ADD_MANUAL_CAMERA_FAILURE,
  payload
});

export const disableNextButton = (value) => ({
  type: types.DISABLE_NEXT_BUTTON,
  payload: value
});

export const addRtspUrl = (value) => ({
  type: types.ADD_RTSP_URL,
  value
});

export const modalOpen = (value) => ({
  type: types.MODAL_OPEN,
  value
});

export const refreshCameraPage = (value) => ({
  type: types.REFRESH_CAMERA_PAGE,
  value
});

export const updateCameraCalibrationStatus = (value) => ({
  type: types.CAMERA_CALIBRATION_UPDATE_STATUS,
  value
});

export const updateCCDStatus = (value) => {
  return {
    type: types.UPDATE_CCD_STATUS,
    payload: value
  };
};
export const fetchCriticalUnresolvedEventsRequest = (activeSession, silentUpdate = false) => ({
  type: types.FETCH_CRITICAL_UNRESOLVED_EVENTS_REQUEST,
  payload: activeSession,
  silentUpdate
});

export const fetchCriticalUnresolvedEventsSuccess = (events, count) => ({
  type: types.FETCH_CRITICAL_UNRESOLVED_EVENTS_SUCCESS,
  payload: { events, count }
});

export const fetchCriticalUnresolvedEventsFailure = () => ({
  type: types.FETCH_CRITICAL_UNRESOLVED_EVENTS_FAILURE
});

export const setCalibrating = (value) => ({
  type: types.SET_CALIBRATING,
  payload: value
});
export const triggerUnpairedCamerasRefresh = () => ({
  type: types.TRIGGER_UNPAIRED_CAMERAS_REFRESH
});

export const resetUnpairedCamerasRefresh = () => ({
  type: types.RESET_UNPAIRED_CAMERAS_REFRESH
});

export const setValid = (value) => {
  return {
    type: types.SET_IS_VALID,
    value
  };
};

export const setUserName = (value) => {
  return {
    type: types.SET_USER_NAME,
    value
  };
};

export const setPassword = (value) => {
  return {
    type: types.SET_PASSWORD,
    value
  };
};

export const setHostName = (value) => {
  return {
    type: types.SET_HOST_NAME,
    value
  };
};

export const setPortName = (value) => {
  return {
    type: types.SET_PORT_NAME,
    value
  };
};

export const setManualApiResponse = (value) => {
  return {
    type: types.SET_MANUAL_API_RESPONSE,
    value
  };
};

export const fetchAppearancesSuccess = (appearances) => ({
  type: types.FETCH_APPEARANCES_SUCCESS,
  payload: appearances
});

export const setAdvancedConfigAppearances = (appearances) => ({
  type: types.SET_ADVANCED_CONFIG_APPEARANCES,
  payload: appearances
});

export const clearAdvancedConfigAppearances = (callFrom = 'unknown') => ({
  type: types.CLEAR_ADVANCED_CONFIG_APPEARANCES,
  payload: { callFrom }
});

export const setAdvancedConfigThresholds = (thresholds) => ({
  type: types.SET_ADVANCED_CONFIG_THRESHOLDS,
  payload: thresholds
});

export const setAdvancedConfigRadio = (radioValue) => ({
  type: types.SET_ADVANCED_CONFIG_RADIO,
  payload: radioValue
});

export const downloadAppearanceImagesSuccess = (appearanceImages) => ({
  type: types.DOWNLOAD_APPEARANCE_IMAGES_SUCCESS,
  payload: appearanceImages
});
export const setSelectedCameraName = (value) => {
  return {
    type: types.SELECTED_CAMERA_UPDATED,
    value
  };
};

export const setExpandedEvent = (value) => {
  return {
    type: types.SAVE_EXPANDED_EVENT,
    value
  };
};

export const clearExpandedEvent = () => {
  return {
    type: types.CLEAR_EXPANDED_EVENT
  };
};

export const fetchIncidentsByFloorRequest = (siteId) => {
  return {
    type: types.FETCH_INCIDENTS_BY_FLOOR_REQUEST,
    payload: siteId
  };
};

export const fetchIncidentsByFloorSuccess = (data) => {
  return {
    type: types.FETCH_INCIDENTS_BY_FLOOR_SUCCESS,
    payload: data
  };
};

export const fetchIncidentsByFloorFailure = (error) => {
  return {
    type: types.FETCH_INCIDENTS_BY_FLOOR_FAILURE,
    payload: error
  };
};

export const setSiteStatsCache = (siteId, data) => ({
  type: types.SET_SITE_STATS_CACHE,
  payload: { siteId, data },
});

export const setSiteStatsPending = (siteId, pending) => ({
  type: types.SET_SITE_STATS_PENDING,
  payload: { siteId, pending },
});

export const checkResolveStatusRequest = (accountID, isPostSubmit = false) => {
  return {
    type: types.CHECK_RESOLVE_STATUS_REQUEST,
    payload: accountID,
    isPostSubmit,
  };
};

export const checkResolveStatusSuccess = (data) => {
  return {
    type: types.CHECK_RESOLVE_STATUS_SUCCESS,
    payload: data
  };
};

export const checkResolveStatusFailure = (error) => {
  return {
    type: types.CHECK_RESOLVE_STATUS_FAILURE,
    payload: error
  };
};

export const startResolveStatusPolling = (accountID) => {
  return {
    type: types.START_RESOLVE_STATUS_POLLING,
    payload: accountID
  };
};

export const stopResolveStatusPolling = () => {
  return {
    type: types.STOP_RESOLVE_STATUS_POLLING
  };
};
export const setUserManagementUsers = (users) => ({
  type: types.SET_USER_MANAGEMENT_USERS,
  payload: users,
});

export const setUserManagementGroups = (groups) => ({
  type: types.SET_USER_MANAGEMENT_GROUPS,
  payload: groups,
});

export const setUserManagementPendingInvites = (invites) => ({
  type: types.SET_USER_MANAGEMENT_PENDING_INVITES,
  payload: invites,
});

export const createForensicSearchResult = (payload) => ({
  type: types.CREATE_FORENSIC_SEARCH_RESULTS,
  payload
});

export const deleteForensicSearchResult = (payload) => ({
  type: types.DELETE_FORENSIC_SEARCH_RESULTS,
  payload
});

export const getImageUrlFromForensicSearchImageIndex = (payload) => ({
  type: types.GET_IMAGE_URL_FORENSIC_SEARCH_IMAGE_INDEX,
  payload
});
export const getImageUrlFromForensicSearchImageIndexResponse = (payload) => ({
  type: types.GET_IMAGE_URL_FORENSIC_SEARCH_IMAGE_INDEX_RESPONSE,
  payload
});

export const getRecentForensicSearchesRequest = (payload) => ({
  type: types.GET_RECENT_FORENSIC_SEARCHES_REQUEST,
  payload
});

export const createForensicSearchResponse = (payload) => ({
  type: types.CREATE_FORENSIC_SEARCH_RESPONSE,
  payload
});
export const deleteForensicSearchResponse = (payload) => ({
  type: types.DELETE_FORENSIC_SEARCH_RESPONSE,
  payload
});


export const fetchedForensicSearchResults = (searchResult) => ({
  type: types.FETCHED_FORENSIC_SEARCH_RESULTS,
 searchResult
});

export const getForensicCreatedSearchStatus = (payload) => ({
  type: types.GET_FORENSIC_SEARCH_STATUS_REQUEST,
  payload
});

export const getForensicSearchStatusResponse = (payload) => ({
  type: types.GET_FORENSIC_SEARCH_STATUS_RESPONSE,
  payload
});

export const updateForensicSearchImagesResponse = (payload) => ({
  type: types.UPDATE_FORENSIC_SEARCH_IMAGES_RESPONSE,
  payload
});

export const updateSiteTagListItem = (kind, id, updates) => ({
  type: types.UPDATE_SITE_TAG_LIST_ITEM,
  payload: { kind, id, updates }
});

export const setSelectedSiteId = (siteId) => ({
  type: types.SET_SELECTED_SITE_ID,
  payload: siteId
});